import { DatePicker, Empty, Input, Table, message, theme } from "antd";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { MakeApiCall } from "../../../../apis";
import InfoVideo from "../../../../components/header-icons";
import Pagination from "../../../../components/pagination";
import { TableLoading } from "../../../../components/table-animation";
import { ENDPOINT, RenderTable } from "../../../../config";
import ExportFile from "./export-file";
import { ErrorModal } from "../../../../components/upload-modals";
const { useToken } = theme;
dayjs.extend(quarterOfYear);
const ExternalTraffic = ({ locationData }) => {
  const CommaAndFloat = (e) => {
    return (e || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const Comma = (e) => {
    return (e || 0).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };
  const performance = [
    {
      title: "Date",
      dataIndex: "report_date",
      key: "report_date",
      width: 150,
    },

    {
      title: "Campaign Name",
      dataIndex: "campaign_id",
      key: "campaign_id",

      render: (e) => {
        if (!e) {
          return "-";
        }
        return <span>{e}</span>;
      },
    },
    {
      title: "Ad Group Name",
      dataIndex: "ad_group_id",
      key: "ad_group_id",

      render: (e) => {
        if (!e) {
          return "-";
        }
        return <span>{e}</span>;
      },
    },
    {
      title: "Publisher",
      dataIndex: "publisher",
      key: "publisher",

      render: (e) => {
        if (!e) {
          return "-";
        }
        return <span>{e}</span>;
      },
    },
    {
      title: "Creative Name",
      dataIndex: "creative_id",
      key: "creative_id",

      render: (e) => {
        if (!e) {
          return "-";
        }
        return <span>{e}</span>;
      },
    },
    {
      title: "Click Throughs",
      dataIndex: "click_throughs",
      key: "click_throughs",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Attributed Add To Cart Clicks14D",
      dataIndex: "attributed_add_to_cart_clicks14d",
      key: "attributed_add_to_cart_clicks14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Brb Bonus Amount ($)",
      dataIndex: "brb_bonus_amount",
      key: "brb_bonus_amount",

      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },

    {
      title: "Attributed Purchases14D",
      dataIndex: "attributed_purchases14d",
      key: "attributed_purchases14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Attributed Detail Page Views Clicks14D",
      dataIndex: "attributed_detail_page_views_clicks14d",
      key: "attributed_detail_page_views_clicks14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Attributed Total Add To Cart Clicks14D",
      dataIndex: "attributed_total_add_to_cart_clicks14d",
      key: "attributed_total_add_to_cart_clicks14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Attributed Total Purchases14D",
      dataIndex: "attributed_total_purchases14d",
      key: "attributed_total_purchases14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Advertiser Name",
      dataIndex: "advertiser_name",
      key: "advertiser_name",

      render: (e) => {
        if (!e) {
          return "-";
        }
        return <span>{e}</span>;
      },
    },
    {
      title: "Total Units Sold14D",
      dataIndex: "total_units_sold14d",
      key: "total_units_sold14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Units Sold14D",
      dataIndex: "units_sold14d",
      key: "units_sold14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Attributed Total Detail Page Views Clicks14D",
      dataIndex: "attributed_total_detail_page_views_clicks14d",
      key: "attributed_total_detail_page_views_clicks14d",

      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Attributed Sales14D ($)",
      dataIndex: "attributed_sales14d",
      key: "attributed_sales14d",

      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Total Attributed Sales14D ($)",
      dataIndex: "total_attributed_sales14d",
      key: "total_attributed_sales14d",

      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
  ];

  const [tableLoading, setTableLoading] = useState(true);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [sortFilters, setSortFilters] = useState({
    field_name: "report_date",
    sort_by: "desc",
  });
  const [file, setFile] = useState({
    fileName: null,
    file: null,
  });
  const [filters, setFilters] = useState({
    search_key: null,
    start_date: dayjs().startOf("month").format("YYYY-MM-DD"),
    end_date: dayjs().endOf("month").format("YYYY-MM-DD"),
  });

  const presetRanges_ = [
    {
      label: "Yesterday",
      value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
    },
    { label: "This Week", value: [dayjs().startOf("week"), dayjs()] },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "Last Month",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: "This Quarter",
      value: [dayjs().startOf("quarter"), dayjs().endOf("quarter")],
    },
    {
      label: "This Year",
      value: [dayjs().startOf("year"), dayjs().endOf("year")],
    },
    {
      label: "Last Year",
      value: [
        dayjs().subtract(1, "year").startOf("year"),
        dayjs().subtract(1, "year").endOf("year"),
      ],
    },
  ];
  const presetRanges = presetRanges_.map((range) => {
    const start = range.value[0];
    let end = range.value[1];

    // Check if the end date is in the future
    if (end.isAfter(dayjs())) {
      end = dayjs(); // Replace with the current date
    }

    return {
      ...range,
      value: [start, end],
    };
  });

  const getList = async (data) => {
    setTableLoading(true);
    const response = await MakeApiCall(
      `advertising/attribution-performance?page=${
        data?.page || page || 1
      }&per-page=${data?.pageSize || pageSize}&field_name=${
        data?.field_name || ""
      }&sort_by=${data?.sort_by || ""}&is_export=0&search_key=${
        data?.search_key || ""
      }&start_date=${data?.start_date || ""}&end_date=${data?.end_date || ""}`,
      "get",
      null,
      true
    );

    if (response?.status) {
      setTableLoading(false);
      setList(response?.data?.records || []);
      setTotalPage(response?.data?.pagination?.totalCount || 0);
      setLoading(false);
    } else {
      setLoading(false);
      setTableLoading(false);
      setTotalPage(0);
      ErrorModal(response?.message);
    }
  };

  useEffect(() => {
    setLoading(true);
    getList({ ...sortFilters, ...filters });
    return () => {};
  }, []);

  const sortType = {
    descend: "desc",
    ascend: "asc",
  };
  const DefaultSortType = {
    desc: "descend",
    asc: "ascend",
  };
  const PropsFilter = (type) => ({
    defaultSortOrder:
      type === sortFilters?.field_name
        ? DefaultSortType?.[sortFilters?.sort_by]
        : [],
    sorter: () => {},
  });
  const handleChange = (_, __, sorter) => {
    const obj = {
      field_name: sortType?.[sorter?.order] ? sorter?.columnKey : "",
      sort_by: sortType?.[sorter?.order] || "",
    };
    setSortFilters(obj);
    getList({ ...obj, ...filters });
  };
  return (
    <div className="card custom-ui">
      <div className="card-header">
        <div className="card-title">
          External Traffic
          <InfoVideo
            data={locationData}
            title={"external_traffic"}
            className={"ms-3"}
          />
          <Input
            onPressEnter={() => {
              getList({
                ...filters,
                ...sortFilters,
              });
            }}
            value={filters?.search_key}
            allowClear
            onChange={(e) => {
              setFilters((prev) => {
                if (!e.target.value && prev) {
                  getList({
                    ...{
                      ...prev,
                      search_key: e.target.value,
                    },
                    ...sortFilters,
                  });
                }
                return {
                  ...prev,
                  search_key: e.target.value,
                };
              });
            }}
            placeholder="Search by campaign name, group name, creative name"
            className="w-175px ms-3"
          />
          <button
            onClick={() => {
              getList({
                ...filters,
                ...sortFilters,
              });
            }}
            className="btn btn-sm ms-3 btn-search"
            style={{ padding: "5px 15px" }}
          >
            <svg
              width={15}
              height={15}
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth={2}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m21 21-2.243-2.247-2.243-2.247" />
              <path d="M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z" />
            </svg>
          </button>
        </div>
        <div className="card-toolbar">
          <DatePicker.RangePicker
            allowClear
            presets={presetRanges}
            value={
              filters?.start_date && filters?.end_date
                ? [
                    dayjs(filters?.start_date, "YYYY-MM-DD"),
                    dayjs(filters?.end_date, "YYYY-MM-DD"),
                  ]
                : []
            }
            onChange={(e) => {
              const obj = {
                ...filters,
                start_date: !e ? null : dayjs(e?.[0])?.format("YYYY-MM-DD"),
                end_date: !e ? null : dayjs(e?.[1])?.format("YYYY-MM-DD"),
              };
              getList({ ...obj, ...sortFilters });
              setFilters(obj);
            }}
            disabledDate={(current) => {
              return current && current > moment().endOf("day");
            }}
            className="w-250px me-3"
          />
          <ExportFile
            paramsBody={{
              source_type: "Data Source",
              record_type: "External Traffic",
              start_date: filters?.start_date,
              end_date: filters?.end_date,
              param_filter: {
                start_date: filters?.start_date,
                end_date: filters?.end_date,
                search_key: filters?.search_key,
              },
            }}
            title="External Traffic"
            hideTooltip={filters?.start_date && filters?.end_date}
            api={`advertising/attribution-performance?start_date=${
              filters?.start_date || ""
            }&end_date=${filters?.end_date || ""}&is_export=1&field_name=${
              sortFilters?.field_name || ""
            }&sort_by=${sortFilters?.sort_by || ""}&search_key=${
              filters?.search_key || ""
            }`}
          />
        </div>
      </div>

      <div className="card-body  pt-0">
        {loading ? (
          <TableLoading
            id="test-table"
            columns={[1, 2, 3, 4, 5]}
            checkBoxVal={true}
            actions={[1, 2]}
          />
        ) : list?.length === 0 ? (
          <Empty style={{ minHeight: "500px" }} />
        ) : (
          <div className="">
            <Table
              dataSource={list}
              fixed={true}
              sticky={{
                offsetHeader: "0px",
              }}
              loading={tableLoading}
              scroll={{ x: "max-content", y: "calc(100vh - 405px)" }}
              columns={performance?.map((d) => ({
                ...d,
                className: "minWidth-table",
                ...PropsFilter(d?.dataIndex),
                render: (props, row, index) =>
                  RenderTable(props, row, index, d),
              }))}
              onChange={handleChange}
              pagination={false}
              rowClassName={(record, index) => {
                return index % 2 === 0 ? "even-row" : "odd-row";
              }}
              bordered
              size="small"
            />
          </div>
        )}
        <Pagination
          loading={loading}
          pageSize={pageSize}
          page={page}
          totalPage={totalPage}
          onPerPage={(e) => {
            setLoading(true);
            setPageSize(e);
            setPage(1);
            getList({
              page: 1,
              pageSize: e,
              ...filters,
              ...sortFilters,
            });
          }}
          onPageNo={(e) => {
            setLoading(true);
            setPage(e);
            getList({
              page: e,
              ...filters,
              ...sortFilters,
            });
          }}
        />
      </div>
    </div>
  );
};

export default ExternalTraffic;
